export default __webpack_public_path__ + "static/media/workforce-health.df131f80.svg";